export enum PayType {
	Day = 1,
	Hour = 2,
}
